const t = {
  name: "Diversity",
  dimensions: { width: 20, height: 21 },
  content: `
    <g clip-path="url(#clip0_3615_130)">
        <path d="M1 19.75L4.5 12.75L8 19.75H1Z" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
        <circle cx="4.5" cy="5.25" r="3.5" fill="none" stroke="currentColor" stroke-width="2"/>
        <rect x="12" y="12.75" width="7" height="7" rx="1" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
        <path d="M12 5.25L15.5 1.75L19 5.25L15.5 8.75L12 5.25Z" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    <defs>
        <clipPath id="clip0_3615_130">
            <rect width="20" height="20" fill="white" transform="translate(0 0.75)"/>
        </clipPath>
    </defs>
  `
};
export {
  t as Diversity
};
